<template>
  <v-sheet class="px-6 py-16 fill-height overflow-y-auto py-6 px-8 px-md-10">
    <h2 class="mb-4 text-title" style="font-size: 1.5rem!important;">Search for any item</h2>
    <v-text-field
      v-model="query" @click:append="handleSearch(query)" @keyup.enter="handleSearch(query)" class="fill-width"
      :hide-details="'auto'" append-icon="mdi-magnify" @click:append-outer="handleSearch"
      placeholder="eg. iPhone 12, Hp laptop" outlined rounded style="border: 1px solid dodgerblue"
    ></v-text-field>
  </v-sheet>
</template>

<script>
export default {
  name: "SearchModal",
  data() {
    return {
      query: ''
    }
  },
  methods: {
    handleSearch() {
      if (!this.query.length) return;
      this.$emit('close');
      this.$router.replace({ path: '/search', query: { q: this.query } });
    },
  }
}
</script>
